export enum FormulaInputMode {
    AliasKey,
    VariableName
}